const IS_PROD = process.env.NODE_ENV === 'production';

/**
 * Warn when disallowed props are passed to a component.
 *
 * @param {string} componentName
 * @param {object} props
 * @param {string[]} disallowedProps
 */
export function warnOnDisallowedProps(
  componentName,
  props,
  disallowedProps
) {
  if (IS_PROD) return;

  for (const key of disallowedProps) {
    if (key in props) {
      console.warn(
        `[${componentName}] Prop "${key}" is not supported. ` +
          `This component is a primitive; layout and validation ` +
          `belong to higher-level components.`
      );
    }
  }
}

/**
 * Normalize a semantic variant to a closed set.
 *
 * @param {string} componentName
 * @param {string | undefined} variant
 * @param {string[]} allowedVariants
 * @param {string} fallback
 */
export function normalizeVariant(
  componentName,
  variant,
  allowedVariants,
  fallback
) {
  if (!variant) return fallback;

  if (!allowedVariants.includes(variant)) {
    if (!IS_PROD) {
      console.warn(
        `[${componentName}] Unknown variant "${variant}". ` +
          `Allowed variants: ${allowedVariants.join(', ')}. ` +
          `Falling back to "${fallback}".`
      );
    }
    return fallback;
  }

  return variant;
}
